// Genera un reporte del campo en una ventana nueva, listo para imprimir o
// "Guardar como PDF" desde el navegador. Sin librerías externas.
const money = (n) => "$ " + Math.round(n || 0).toLocaleString("es-UY");
const esc = (s) => String(s == null ? "" : s).replace(/[&<>]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export function imprimirReporte({ nombreCampo, ubicacion, potreros = [], transacciones = [], totalHa = 0, totalAnim = 0, cargaGlobal = 0 }) {
  const w = window.open("", "_blank", "width=900,height=1000");
  if (!w) { alert("Permití las ventanas emergentes para generar el reporte."); return; }

  const hoy = new Date().toLocaleDateString("es-UY", { day: "numeric", month: "long", year: "numeric" });
  const mes = new Date().toISOString().slice(0, 7);
  const txMes = transacciones.filter(t => (t.fecha || "").slice(0, 7) === mes);
  const ing = txMes.filter(t => t.tipo === "ingreso").reduce((s, t) => s + (t.monto || 0), 0);
  const egr = txMes.filter(t => t.tipo === "egreso").reduce((s, t) => s + (t.monto || 0), 0);
  const res = ing - egr;

  const activos = potreros.flatMap(p => (p.animalesAsignados || [])).filter(a => (a.estado || "activo") === "activo");
  const comp = {};
  activos.forEach(a => { const k = a.categoria || "Sin categoría"; comp[k] = (comp[k] || 0) + 1; });

  const catEg = {};
  txMes.filter(t => t.tipo === "egreso").forEach(t => { catEg[t.categoria] = (catEg[t.categoria] || 0) + (t.monto || 0); });

  const rowsPot = potreros.map(p => `<tr>
    <td>${esc(p.nombre)}</td><td class="r">${(p.ha || 0).toFixed(1)}</td>
    <td>${esc(p.pasto || "")}</td><td>${esc(p.estado || "")}</td>
    <td class="r">${(p.animalesAsignados || []).length}</td></tr>`).join("");

  const rowsComp = Object.entries(comp).sort((a, b) => b[1] - a[1])
    .map(([k, n]) => `<tr><td>${esc(k)}</td><td class="r">${n}</td></tr>`).join("") || `<tr><td colspan="2">Sin animales cargados</td></tr>`;

  const rowsEg = Object.entries(catEg).sort((a, b) => b[1] - a[1])
    .map(([k, v]) => `<tr><td>${esc(k)}</td><td class="r">${money(v)}</td></tr>`).join("") || `<tr><td colspan="2">Sin egresos este mes</td></tr>`;

  w.document.write(`<!doctype html><html lang="es"><head><meta charset="utf-8">
  <title>Reporte · ${esc(nombreCampo || "Campo")}</title>
  <style>
    *{box-sizing:border-box} body{font-family:Georgia,'Times New Roman',serif;color:#1A1A18;margin:0;padding:32px 40px;background:#fff}
    .head{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #2D5A34;padding-bottom:12px;margin-bottom:18px}
    h1{font-size:26px;margin:0;color:#1F120A} .sub{color:#5F5F55;font-size:13px;margin-top:4px}
    .logo{font-size:22px;font-weight:bold;color:#2D5A34}
    h2{font-size:15px;color:#2D5A34;border-bottom:1px solid #D4CCC0;padding-bottom:5px;margin:22px 0 10px;text-transform:uppercase;letter-spacing:.04em;font-family:Arial,sans-serif}
    .kpis{display:flex;gap:12px;flex-wrap:wrap;margin-bottom:6px}
    .kpi{flex:1;min-width:130px;border:1px solid #D4CCC0;border-radius:8px;padding:11px 13px}
    .kpi .l{font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#8C8C7E;font-family:Arial,sans-serif}
    .kpi .v{font-size:22px;font-weight:bold;margin-top:3px}
    table{width:100%;border-collapse:collapse;font-family:Arial,sans-serif;font-size:12.5px}
    th,td{text-align:left;padding:6px 8px;border-bottom:1px solid #E5DFD2} th{color:#5F5F55;font-size:10.5px;text-transform:uppercase;letter-spacing:.04em}
    td.r,th.r{text-align:right} .ok{color:#28641F} .bad{color:#8B1F1F}
    .foot{margin-top:26px;color:#8C8C7E;font-size:11px;font-family:Arial,sans-serif;text-align:center;border-top:1px solid #D4CCC0;padding-top:10px}
    @media print{body{padding:16px}.noprint{display:none}}
    .btn{background:#2D5A34;color:#fff;border:none;border-radius:8px;padding:9px 18px;font-size:14px;cursor:pointer;font-family:Arial}
  </style></head><body>
    <div class="noprint" style="text-align:right;margin-bottom:14px"><button class="btn" onclick="window.print()">🖨️ Imprimir / Guardar PDF</button></div>
    <div class="head">
      <div><h1>${esc(nombreCampo || "Mi Campo")}</h1><div class="sub">${esc(ubicacion || "")}${ubicacion ? " · " : ""}Reporte al ${hoy}</div></div>
      <div class="logo">🌾 CampoIA</div>
    </div>

    <h2>Resumen del campo</h2>
    <div class="kpis">
      <div class="kpi"><div class="l">Hacienda activa</div><div class="v">${totalAnim} cab.</div></div>
      <div class="kpi"><div class="l">Superficie</div><div class="v">${Math.round(totalHa)} ha</div></div>
      <div class="kpi"><div class="l">Carga animal</div><div class="v">${Number(cargaGlobal || 0).toFixed(2)} UG/ha</div></div>
      <div class="kpi"><div class="l">Potreros</div><div class="v">${potreros.length}</div></div>
    </div>

    <h2>Economía del mes</h2>
    <div class="kpis">
      <div class="kpi"><div class="l">Ingresos</div><div class="v ok">${money(ing)}</div></div>
      <div class="kpi"><div class="l">Egresos</div><div class="v bad">${money(egr)}</div></div>
      <div class="kpi"><div class="l">Resultado</div><div class="v ${res >= 0 ? "ok" : "bad"}">${res >= 0 ? "+" : "−"} ${money(Math.abs(res))}</div></div>
      <div class="kpi"><div class="l">Resultado / cabeza</div><div class="v">${totalAnim > 0 ? money(res / totalAnim) : "—"}</div></div>
    </div>
    <table style="margin-top:10px"><thead><tr><th>Egresos por categoría</th><th class="r">Monto</th></tr></thead><tbody>${rowsEg}</tbody></table>

    <h2>Potreros</h2>
    <table><thead><tr><th>Potrero</th><th class="r">Ha</th><th>Pasto</th><th>Estado</th><th class="r">Animales</th></tr></thead>
      <tbody>${rowsPot || `<tr><td colspan="5">Sin potreros</td></tr>`}</tbody></table>

    <h2>Composición del rodeo</h2>
    <table><thead><tr><th>Categoría</th><th class="r">Cabezas</th></tr></thead><tbody>${rowsComp}</tbody></table>

    <div class="foot">Generado por CampoIA · ${hoy}</div>
  </body></html>`);
  w.document.close();
  w.focus();
}
